module.exports = __webpack_public_path__ + "static/logo-af96b463809e1763abe68eca5819ef4b.png";